// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + "handsontable" + "-" + "e160638a04e1d49b5886" + ".css";
};